module.exports = __webpack_public_path__ + "static/img/p2.a01383e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/img/product/p2.jpg
// module id = +Fi+
// module chunks = 1